/* eslint-disable default-case */
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from 'universal-cookie'
import { io } from "socket.io-client";
import { isRealAuthToken, Logout } from "./common/Funcation";
import { ADMIN_API, USER_API } from "./common/common";

const cookies = new Cookies()



let socket;

export const getToken = async () => {
  try {
    const auth_token = cookies.get("skyTokenFront");
    return isRealAuthToken(auth_token) ? auth_token : null;
  } catch (e) {
    return null;
  }
};

function authHeaders(explicitToken, cookieToken) {
  const token = explicitToken || cookieToken;
  if (!isRealAuthToken(token)) return {};
  return { Authorization: token };
}

const apiURL = process.env.REACT_APP_API_USER_ENDPOINT;
function skipAuth(data) {
  return data?.anonymous || data?.api === "admin/login" || data?.api === "home";
}

export const postApi = async (data) => {
  const auth_token = await getToken()
  return axios.post(`${apiURL + data.api}`, data.value, {
    headers: skipAuth(data) ? {} : authHeaders(data.token, auth_token),
  });
};
export const postApiLink = async (data) => {
  const auth_token = await getToken()

  return axios.post(`${data.api}`, data.value, {
    headers: skipAuth(data) ? {} : authHeaders(data.token, auth_token),
  });
};

const apiURL_ADMIN = process.env.REACT_APP_API_ENDPOINT;
export const postApiAdmin = async (data) => {
  const auth_token = await getToken()

  return axios.post(`${apiURL_ADMIN + data.api}`, data.value, {
    headers: skipAuth(data) ? {} : authHeaders(data.token, auth_token),
  });
};

export const getApi = async (data) => {
  const auth_token = await getToken()
  return axios.get(`${apiURL + data.api}`, {
    headers: skipAuth(data) ? {} : authHeaders(data.token, auth_token),
  });
};


export const getApiWithData = async (data) => {
  const auth_token = await getToken()
  return axios.get(`${apiURL + data.api}`, { params: data.value }, {
    headers: skipAuth(data) ? {} : authHeaders(data.token, auth_token),
  });
};

export const getApiLink = async (data) => {
  return axios.get(`${data.api}`, { maxBodyLength: "Infinity" });
};

export const notifyMessage = (text) => toast.success(text, {
  className: 'toast-success-container toast-success-container-after',
});
export const notifyError = (text) => toast.error(text, {
  className: 'toast-error-container toast-error-container-after',
});

function normalizeSiteHost(host) {
  if (!host) return "";
  let domain = String(host).toLowerCase();
  if (domain.includes("ag.")) {
    domain = domain.split("ag.")[1] || domain;
  } else if (domain.includes("msa.")) {
    domain = domain.split("msa.")[1] || domain;
  }
  return domain.replace(/^www\./, "");
}

function getClientHostname() {
  if (typeof window === "undefined") return "";
  if (window.location.hostname === "localhost" && process.env.REACT_APP_DOMAIN) {
    return process.env.REACT_APP_DOMAIN;
  }
  return window.location.hostname;
}

function isCacheEventForThisSite(eventDomain) {
  if (!eventDomain) return false;
  return normalizeSiteHost(eventDomain) === normalizeSiteHost(getClientHostname());
}

// async function refetchWebsiteCache(dispatch) {
//   const hostname = getClientHostname();
//   try {
//     const homeRes = await getApi({
//       api: `${USER_API.HOME}?domain=${hostname}`,
//     });
//     if (homeRes?.data?.data) {
//       dispatch({ type: "SET_HOME_DATA", payload: homeRes.data.data });
//     }
//   } catch (err) {
//     console.error("CACHE_INVALIDATE home refetch failed", err);
//   }
//   try {
//     const siteRes = await postApiAdmin({
//       api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
//       value: { domain: hostname },
//       anonymous: true,
//     });
//     if (siteRes?.data?.data) {
//       dispatch({ type: "DOMAIN_DETAILS", payload: siteRes.data.data });
//     }
//   } catch (err) {
//     console.error("CACHE_INVALIDATE site refetch failed", err);
//   }
// }


async function refetchWebsiteCache(dispatch, getState) {
  const hostname = getClientHostname();

  // 1. Refresh Home data (existing functionality)
  try {
    const homeRes = await getApi({
      api: `${USER_API.HOME}?domain=${hostname}`,
    });

    if (homeRes?.data?.data) {
      dispatch({
        type: "SET_HOME_DATA",
        payload: homeRes.data.data,
      });
    }
  } catch (err) {
    console.error("CACHE_INVALIDATE home refetch failed", err);
  }

  // 2. Refresh website settings (existing functionality)
  try {
    const siteRes = await postApiAdmin({
      api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
      value: { domain: hostname },
      anonymous: true,
    });

    if (siteRes?.data?.data) {
      dispatch({
        type: "DOMAIN_DETAILS",
        payload: siteRes.data.data,
      });
    }
  } catch (err) {
    console.error("CACHE_INVALIDATE site refetch failed", err);
  }

  // 3. Refresh all casino entries already present in Redux cache
  const casinoCache = getState?.()?.casinoCache || {};
  const cacheEntries = Object.keys(casinoCache);

  await Promise.all(
    cacheEntries.map(async (cacheKey) => {
      // Cache key format: type:filter:subName
      const [type, filter] = cacheKey.split(":");

      if (!type || !filter) return;

      try {
        const response = await getApiWithData({
          api: USER_API.GET_CASINO,
          value: {
            gameType: type,
            filter,
            domain: hostname,
          },
        });

        const latestData = response?.data?.data;

        // Replace the cached data only when the API returns data
        if (latestData !== undefined && latestData !== null) {
          dispatch({
            type: "SET_GAME_DATA",
            payload: {
              type,
              filter,
              subName: "",
              data: latestData,
            },
          });
        }
      } catch (err) {
        // Preserve existing cache if the refresh fails
        console.error(
          `CACHE_INVALIDATE casino refetch failed for ${cacheKey}`,
          err
        );
      }
    })
  );
}




export const socketConnect = async (dispatch, next, getState) => {
  const socketApi = process.env.REACT_APP_BASE_POINT;
  // const socketApi = '172.20.11.108:3002';
  socket = io(socketApi, { transports: ['websocket'] });
  socket.on("connect", (res) => {
    next(socket.connected);
  });
  socket.on("res", (data) => {
    const response = getResponse(data)
    if (response) {
      switch (response.data.en) {
        case 'GET_USER_COUNT': {
          dispatch({ type: 'GET_USER_COUNT', payload: response.data.data })
          break;
        }
        case 'GET_LIVE_MATCH_COUNT_FOR_VELKI': {
          dispatch({ type: 'GET_LIVE_MATCH_COUNT_FOR_VELKI', payload: response.data.data })
          break;
        }
        case 'GET_SPORTS_DETAILS': {
          dispatch({ type: 'GET_SPORTS_DETAILS', payload: response.data.data })
          break;
        }
        case 'UPDATE_USER_BALANCE': {
          dispatch({ type: 'UPDATE_USER_BALANCE', payload: response.data.data })
          break;
        }
        case 'GET_SPORTS': {
          dispatch({ type: 'GET_SPORTS', payload: response.data.data })
          break;
        }
        case 'GET_INPLAY_MATCHES': {
          dispatch({ type: 'GET_INPLAY_MATCHES', payload: response.data.data })
          break;
        }
        case 'GET_SCORE_ID': {
          dispatch({ type: 'GET_SCORE_ID', payload: response.data.data.result })
          break;
        }
        case 'VERIFY_TOKEN': {
          if (response.data?.data?.status === 401 && isRealAuthToken(cookies.get("skyTokenFront"))) {
            dispatch({ type: 'LOGOUT', payload: {} })
            Logout()
          }
          break;
        }
        case 'FORCE_LOGOUT': {
          const keepToken = response.data?.data?.keepToken;
          const current = cookies.get("skyTokenFront");
          if (keepToken && current && String(current) === String(keepToken)) {
            break;
          }
          dispatch({ type: 'LOGOUT', payload: {} })
          Logout()
          break;
        }
        case 'CACHE_INVALIDATE': {
          if (!isCacheEventForThisSite(response.data?.domain)) {
            break;
          }
          refetchWebsiteCache(dispatch, getState);
          break;
        }
      }
    }
  });
};

export const getResponse = (data) => {
  return data
}

const requestHandler = (event, data) => {
  return { en: event, data }
}

export const sendEvent = (event, data) => {
  if (socket) {
    socket.emit("req", requestHandler(event, data))
  } else {
    console.warn("Socket not initialized yet, skipping event:", event)
  }
}